var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-cover-wrapper"},[_c('el-image',{staticClass:"empty-cover-image",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_setup.EMPTY_COVER,"fit":"cover"}}),_c('div',{staticClass:"empty-cover-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }